import { render } from "./KidneySpecificSectionDetails.vue?vue&type=template&id=92508f4a&scoped=true"
import script from "./KidneySpecificSectionDetails.vue?vue&type=script&lang=js"
export * from "./KidneySpecificSectionDetails.vue?vue&type=script&lang=js"

import "./KidneySpecificSectionDetails.vue?vue&type=style&index=0&id=92508f4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92508f4a"],['__file',"src/components/KidneySpecificSectionDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "92508f4a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('92508f4a', __exports__)) {
    api.reload('92508f4a', __exports__)
  }
  
  module.hot.accept("./KidneySpecificSectionDetails.vue?vue&type=template&id=92508f4a&scoped=true", () => {
    api.rerender('92508f4a', render)
  })

}


export default __exports__